import React, { useEffect } from 'react';
import Lenis from '@studio-freight/lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Navbar from './navbar';
import Footer from './Footer';
import ModernHeroSection from './landing/ModernHeroSection';
import AIFeaturesSection from './landing/AIFeaturesSection';
import VideoShowcaseSection from './landing/VideoShowcaseSection';
import GallerySection from './landing/GallerySection';
import ExtensionSection from './landing/ExtensionSection';
import FAQ from './faq';
import './landing/landing.css';

gsap.registerPlugin(ScrollTrigger);

const LandingPage = () => {
  useEffect(() => {
    // Initialize Lenis smooth scroll
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    // Integrate Lenis with ScrollTrigger
    lenis.on('scroll', ScrollTrigger.update);

    // Use GSAP ticker for Lenis - store function reference for cleanup
    const tickerFunction = (time) => {
      lenis.raf(time * 1000);
    };
    gsap.ticker.add(tickerFunction);
    gsap.ticker.lagSmoothing(0);

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }

    rafId = requestAnimationFrame(raf);

    // Refresh ScrollTrigger after a short delay to ensure DOM is ready
    const refreshTimeout = setTimeout(() => {
      ScrollTrigger.refresh();
    }, 100);

    return () => {
      // Cancel RAF
      if (rafId) {
        cancelAnimationFrame(rafId);
      }
      
      // Remove ticker function
      try {
        gsap.ticker.remove(tickerFunction);
      } catch (e) {
        // Ignore if already removed
      }
      
      // Clear timeout
      clearTimeout(refreshTimeout);
      
      // Destroy Lenis
      try {
        lenis.destroy();
      } catch (e) {
        // Ignore cleanup errors
      }
      
      // Clean up all ScrollTriggers safely
      try {
        const triggers = ScrollTrigger.getAll();
        triggers.forEach(trigger => {
          try {
            if (trigger && typeof trigger.kill === 'function') {
              trigger.kill();
            }
          } catch (e) {
            // Ignore individual cleanup errors
          }
        });
      } catch (e) {
        // Ignore if ScrollTrigger is not available
      }
    };
  }, []);

  return (
    <div className="landing-page">
      <Navbar />
      <ModernHeroSection />
      <AIFeaturesSection />
      <VideoShowcaseSection />
      <GallerySection />
      <ExtensionSection />
      <FAQ />
      <Footer />
    </div>
  );
};

export default LandingPage;

